import React from "react";
import { Sparkles, X } from "lucide-react";

export const AiPrioritiesModal = ({ open, loading, priorities, error, onClose }) => {
  if (!open) return null;
  return <div className="ai-modal" data-testid="ai-priorities-modal" onClick={onClose}>
    <div className="ai-card" onClick={event => event.stopPropagation()}>
      <button className="close" onClick={onClose} data-testid="ai-priorities-close"><X size={20} /></button>
      <p className="eyebrow" style={{ margin: 0, fontSize: 10, letterSpacing: ".11em", textTransform: "uppercase", color: "var(--muted)" }}>INGEGO AI</p>
      <h2>Priorità suggerite per oggi</h2>
      <p className="muted" style={{ fontSize: 12.5, margin: "4px 0 0" }}>Suggerimenti calcolati su scadenze, responsabilità, ritardi e quote maturate. Nessuna pratica viene modificata.</p>
      {loading && <p className="muted" data-testid="ai-priorities-loading" style={{ marginTop: 20 }}>Analisi in corso…</p>}
      {error && <div className="error" role="alert" data-testid="ai-priorities-error">{error}</div>}
      {!loading && !error && <ol>
        {priorities.map((item, index) => <li key={`${item.action}-${index}`} data-testid={`ai-priority-${index}`}>
          <div><strong>{item.action}</strong>{item.practice && <small>{item.practice}</small>}{item.reason && <small>{item.reason}</small>}</div>
        </li>)}
        {!priorities.length && <li data-testid="ai-priorities-empty"><div><strong>Nessuna priorità critica</strong><small>Lo studio è in pari con le attività aperte.</small></div></li>}
      </ol>}
    </div>
  </div>;
};

export const AiPrioritiesButton = ({ loading, onClick }) => <button className="cr-ai-btn" disabled={loading}
  data-testid="ai-priorities-btn" onClick={onClick}><Sparkles size={15} />{loading ? "Analisi in corso…" : "Analizza le priorità con AI"}</button>;
